import axios from 'axios';
import { ref, get, set } from 'firebase/database';
import { devLog } from '@lib/util/logging';
import { isDevSite, useTestData } from '@lib/util/site';
import db from '@services/db';

import getApiBaseUrl from './index';

const authUri = (): Promise<string> => new Promise((resolve, reject) => {
  let apiUrl = `${getApiBaseUrl()}/authUri`;
  if (isDevSite()) apiUrl = `${getApiBaseUrl()}/authUri-dev`;
  if (useTestData) apiUrl = `${getApiBaseUrl()}/authUri-staging`;

  axios.get(apiUrl)
    .then((authUrl) => {
      resolve(authUrl.data as unknown as string);
    })
    .catch((e) => {
      console.log(e);
      reject(e);
    });
});

const retrieveToken = ():Promise<string> => new Promise((resolve, reject) => {
  axios.get(`${getApiBaseUrl()}/retrieveToken`).then((data) => {
    resolve(data.data);
  });
});
const refreshToken = (authPath: string): Promise<object|string> => new Promise((resolve, reject) => {
  // const _refreshToken = localStorage.getItem('qbo.refreshToken');
  const authRef = ref(db.database, authPath);
  get(authRef).then((authData) => {
    const _refreshToken = authData.val().refresh_token;
    const url = _refreshToken ? `${getApiBaseUrl()}/refreshAccessToken?token=${_refreshToken}` : `${getApiBaseUrl()}/refreshAccessToken`;
    axios.get(url)
      .then((data) => {
        set(authRef, data.data).then(() => {
          devLog('qboApi:refreshToken', 32, data.data);
          localStorage.setItem('qbo.refreshToken', data.data.refresh_token);
          resolve(data.data);
        });
      })
      .catch((e) => {
        devLog('qboApi:refreshToken', 37, e);
        reject(e);
      });
  });
});

export default {
  authUri,
  retrieveToken,
  refreshToken,
};
